module.exports = __webpack_public_path__ + "static/media/ETH-BTC.f1759fe8.png";